import React from 'react'

export default function ConfigureBenefitGroups() {
  const data:any = [
    { Benifit: 'maternity',icds:"523/265/4000"},
    {icds:4850},
    {},
    {},

  ];
  return (
    <div className=' container'style={{margin:"30px"}} >
      {/* title */}
<h5>Configure Benefit Groups Screen <span> <i className='bi bi-people '></i>    </span>   </h5>

<h5 style={{margin:"20px"}}>Add New Benefit  </h5>

{/* first row input */}

<div className=' row d-flex flex-row w-100 ' style={{ marginTop:"20px"}}>
 <select name="BenifitName" id=""className='  p-1 ' style={{marginLeft:"7px",width:"25%"}}>
  

<option value="BenifitName">Benifit Name</option>

 </select>
 <input type="text" className="form-control " placeholder="Search ICD "style={{marginLeft:"7px",width:"20%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>

 <button className="btn btn-info " type="submit"  style={{marginLeft:"7px",width:"15%"}}> <span className=' m-2'><i className="fa-solid fa-plus"></i></span>Add</button>

   <input type="text" className="form-control " placeholder="Search "style={{marginLeft:"7px",width:"20%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>




</div>

{/* table */}
<table className=' text-center' style={{  width: '100%' , marginTop:"40px" }}>
      <thead>
        <tr>
          <th style={{ border: '1px solid #ddd', padding: '5px' }}>Benifit Name</th>
          <th style={{ border: '1px solid #ddd', padding: '5px' }}>ICDs</th>
          <th style={{ border: '1px solid #ddd', padding: '5px' }}>Actions</th>

        </tr>
      </thead>
      <tbody>
        {data.map((item:any,index:number) => (
          <tr key={item.id} className=' text-center' style={{
            background: index % 2 === 0 ? '#74C0FC' : '#ffffff', 
            border: '1px solid #ddd',
            padding: '8px',
          }}>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.Benifit}</td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.icds}</td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}><span><i className="fa fa-solid fa-edit m-2"> </i>
            <i className="fa-solid fa-trash"></i></span></td>          </tr>
          
        ))}
      </tbody>
    </table>
 
    </div>
  )
}
